import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdPostAdd } from 'react-icons/md'
import Button from '../../Formik/Button'
import PaymentGuard from '../PaymentGuard'
import { useAccounting } from '../lib/Hooks/Accounting'
import SpendForm from './SpendForm'

type Props = {
  accountingDate?: Date
}

const AddSpend: FC<Props> = ({ accountingDate }) => {
  const { t } = useTranslation(['accounting'])
  const { data: accounting } = useAccounting()
  const [showForm, toggleForm] = useState(false)

  return (
    <PaymentGuard sheet={accounting!}>
      {(guard) => (
        <>
          <SpendForm
            show={showForm}
            hideModal={() => toggleForm(false)}
            accountingDate={accountingDate}
          />

          <Button
            onClick={guard(() => toggleForm(true))}
            theme='blue'
            size='sm'
          >
            <div className='flex items-center'>
              <MdPostAdd className='mr-2' />
              {t('accounting:addSpend.newEntry')}
            </div>
          </Button>
        </>
      )}
    </PaymentGuard>
  )
}

export default AddSpend
